module.exports = __webpack_public_path__ + "static/media/CRONA.f2da6d5c.svg";